/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { FunctionComponent, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { IRootState } from "../../config/reducers";
import { NavItemProps } from "../../types/sidebar";

const NavItem: FunctionComponent<NavItemProps> = (props: NavItemProps) => {
  const {
    title,
    icon,
    href,
    expandParent,
    type,
    selectItem,
    activeItem,
    onLinkClick,
    badgeCount,
    className,
  } = props;
  const location = useLocation();
  const { expand, unfold } = useSelector(
    (state: IRootState) => state.sidebarReducer
  );
  useEffect(() => {
    if (href && location.pathname.includes(href) && type === "item") {
      if (expandParent) {
        expandParent();
      }
    }
  }, []);

  const selectActiveItem = useCallback(() => {
    if (href && location.pathname.includes(href) && type === "item") {
      selectItem(href);
    }
  }, [location, href]);

  useEffect(() => {
    selectActiveItem();
  }, [location]);

  const getBadge = () => {
    if (badgeCount && badgeCount > 0)
      return (
        <div
          className={`badge bg-danger  ${
            !expand && !unfold ? "badge-absolute" : "ml-1"
          }`}
        >
          {" "}
          {badgeCount}{" "}
        </div>
      );
    return <></>;
  };

  const getIcon = (i: string) => {
    if (icon === "remote_ae") {
      return (
        <span
          style={{
            width: 16,
            fontFamily: "glyphterregular",
            marginRight: "1.2rem",
          }}
        >
          A
        </span>
      );
    }

    if (!expand && !unfold) {
      return (
        <>
          <i className={i} />
          {getBadge()}
        </>
      );
    }
    return <i className={i} />;
  };

  return (
    <li className={`nav-item ${className || ""}`}>
      <Link
        onClick={() => {
          if (onLinkClick) onLinkClick();
        }}
        to={href || "/"}
        className={`nav-link ${activeItem === href ? "active" : ""}`}
      >
        {icon && getIcon(icon)}
        <span>
          {title}
          {getBadge()}
        </span>
      </Link>
    </li>
  );
};

export default NavItem;
